import { Heading, Icon, Paragraph } from '@zillow/constellation-10';
import { IconCheckmarkCircleFilled } from '@zillow/constellation-icons';
import { usePropertyInfoQuery } from '../../../utils/queries';
import { useLeasingUrlParams } from '../../../hooks/useLeasingUrlParams';

export default function YourLinkWasSent() {
  const { propertyId } = useLeasingUrlParams();

  const propertyInfoQuery = usePropertyInfoQuery(propertyId);

  return (
    <>
      <Icon size="lg" role="img" css={{ marginBottom: 'loose', color: 'icon.feedback.success.strong' }}>
        <IconCheckmarkCircleFilled />
      </Icon>
      <Heading level={2} fontFamily="heading-alt" css={{ textStyle: 'responsive.heading-md', marginBottom: 'loose' }}>
        You’re all set
      </Heading>
      <Paragraph css={{ marginBottom: 'loose' }}>
        We’ll save your property and rental history in case you decide to start renting{' '}
        {propertyInfoQuery?.data?.streetAddress} again.
      </Paragraph>
    </>
  );
}
